<template>
	<div class="survey">
		<div class="survey-container mt-10">
			<div style="text-align: right; margin-top:-45px; margin-right:-45px;">
        <img
          width="119"
          :src="$apiUrl + '/storage/Bg8XEkf1nTHbNxaJ6KlBbu7t20s7HFkS8hVrhb7A.png'"
          alt=""
        />
			</div>

			<div v-show="stepIndex === 0">
				<h2>Svenska Bostäder</h2>
				<p><strong>Enkät om avfallshanteringen i ditt hus</strong></p>
				<p>Tack för att du registrerat dig. Vi vill gärna veta mer om hur våra hyresgäster sorterar sopor så du får gärna fylla i enkäten nedan. Efter att du fyllt i den kommer du till vår plattform för bättre avfallshantering. Vill du inte fylla i enkäten kan du <strong><a href="/{slug}">gå direkt till tjänsten</a></strong>.</p>
				<p>För att få reda lite mer på hur avfallshanteringen fungerar i Svenska Bostäders områden ber vi om din hjälp att svara på några frågor.</p>
				<p>Enkäten är helt anonym. Vi vill endast att frågorna besvaras en gång för varje hushåll. Om flera i hushållet fått enkäten så räcker det alltså med att en av er besvarar den, eller att ni gör det tillsammans.</p>

				<h3>Inledande frågor om dig och ditt boende</h3>

				<h4 class="mb-3 mt-10">Vilken adress bor du på?</h4>
				<v-text-field hide-details solo v-model="address"></v-text-field>

				<h4 class="mb-3 mt-10">Vilket år är du född?</h4>
				<v-text-field hide-details solo v-model="yearOfBirth"></v-text-field>

				<h4 class="mb-3 mt-10">Vad identifierar du dig som?</h4>
				<v-radio-group class="mt-0" v-model="gender" column>
					<v-radio label="Man" value="Man"></v-radio>
					<v-radio label="Kvinna" value="Kvinna"></v-radio>
					<v-radio label="Annat/Vill ej uppge" value="Annat/Vill ej uppge"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Hur många personer ingår i ditt hushåll?</h4>
				<v-select hide-details solo :items="personsInHoushold" v-model="personsInHousholdValue" label="Standard"></v-select>

				<h4 class="mb-3 mt-10">Bor det barn i ditt hushåll?</h4>
				<v-checkbox hide-details v-model="childrenInHousehold" value="Ja, upp till 12 år" label="Ja, upp till 12 år"></v-checkbox>
				<v-checkbox	hide-details v-model="childrenInHousehold" value="Ja, tonåring/tonåringar" label="Ja, tonåring/tonåringar"></v-checkbox>
				<v-checkbox hide-details v-model="childrenInHousehold" value="Nej" label="Nej"></v-checkbox>

				<h4 class="mb-3 mt-10">Hur länge har du bott i din nuvarande bostad?</h4>
				<v-select hide-details solo :items="yearsInHoushold" v-model="yearsInHousholdValue" label="-- välj antal år --"></v-select>

				<h4 class="mb-3 mt-10">Ungefär hur ofta källsorterar ditt hushåll i miljöstugan?</h4>
				<v-radio-group class="mt-0" v-model="sortFrequency" row>
					<v-radio label="Mer än en gång i veckan" value="Mer än en gång i veckan"></v-radio>
					<v-radio label="En gång i veckan" value="En gång i veckan"></v-radio>
					<v-radio label="En gång varannan vecka" value="En gång varannan vecka"></v-radio>
					<v-radio label="En gång i månaden" value="En gång i månaden"></v-radio>
					<v-radio label="Mer sällan" value="Mer sällan"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Hur god kännedom anser du att du har om kretsloppsanpassad avfallshantering? <span style="font-weight:normal;">(på en skala från 1 "Inget" och 7 "Mycket god kännedom")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="assessedKnowledge"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="assessedKnowledgeCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div style="clear:both;"></div>
			</div>

			<div v-show="stepIndex === 1">
				<h3>Hur mycket eller lite håller du med om följande påståenden?</h3>

				<h4 class="mb-3 mt-10">När jag befinner mig i miljöstugan får jag en positiv känsla och blir motiverad att sortera mitt avfall. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="feelingWhenRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="feelingWhenRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Det är viktigt ur miljösynpunkt att källsortera avfallet. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="importanceOfRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="importanceOfRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Jag förstår hur jag ska källsorterar mitt avfall. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="understandingOfRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="understandingOfRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Jag har som boende fått bra information om hur avfallet ska sorteras i miljöstugan. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="informedAboutRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="informedAboutRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Jag vet vad som händer med de olika typerna av avfall när det har sorterats. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="understandingOfWhatHappendsAfterRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="understandingOfWhatHappendsAfterRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Det är nära, enkelt och känns tryggt att ta avfallet från bostaden till miljöstugan. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="easeOfRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="easeOfRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Jag har tid att sortera mitt avfall. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="timeToRecycle"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="timeToRecycleCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">Upplägget på miljöstugorna, nedkasten för hushållsavfall och andra avfallskärl som hör till oss som bor här i byggnaden gör det lätt att slänga sitt avfall i hushållsavfall jämfört med att sortera det. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="easeOfWaste"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="easeOfWasteCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">I miljöstugan är det fysiskt enkelt att sortera avfallet (t ex vad gäller lockens tyngd, enkelt att komma intill kärlen, väl skyltat etc)<span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="physicalEaseOfRecycling"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="physicalEaseOfRecyclingCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>


				<h4 class="mb-3 mt-10">I min bostad har jag ett bra utrymme och bra möjligheter att sortera och förvara avfallet innan jag tar det till miljöstugan. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="spaceToRecycle"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="spaceToRecycleCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<h4 class="mb-3 mt-10">De flesta i mitt område sorterar sitt avfall. <span style="font-weight:normal;">(på en skala från 1 "Håller inte alls med" och 7 "Håller helt med")</span></h4>
				<vue-slider class="pb-10" thumb-label="always" always-dirty marks ticks="always" tick-size="4" :max="7" :min="1" v-model="doOthersRecycle"></vue-slider>
				<v-subheader>	Utveckla gärna ditt svar med en kommentar eller ett råd:</v-subheader>
		  		<v-textarea rows="4" hide-details solo v-model="doOthersRecycleCommentary"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<div v-show="stepIndex === 2">
				<h3>För att få en bild av vad Svenska Bostäders hyresgäster kan om avfallshantering ber vi er att svara på följande frågor</h3>

				<h4 class="mb-3 mt-10">Vad är avfallstrappan?</h4>
				<v-radio-group class="mt-0" v-model="knowledgeAvfallstrappan" column>
					<v-radio label="Avfallstrappan är ett sorteringssystem som man kan ha i en miljöstuga" value="a"></v-radio>
					<v-radio label="Avfallstrappan består av 5 nivåer som stegvis beskriver hur avfall ska sorteras och behandla" value="b"></v-radio>
					<v-radio label="Avfallstrappan är ett kunskapstest om avfallshantering" value="c"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Var slänger man farligt avfall?</h4>
				<v-radio-group class="mt-0" v-model="knowledgeFarligtAvfall" column>
					<v-radio label="Farligt avfall lämnas i miljörummet" value="a"></v-radio>
					<v-radio label="I restavfallet" value="b"></v-radio>
					<v-radio label="Farligt avfall lämnas på en återvinningscentral" value="c"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Vad är skillnaden på matavfall och matsvinn?</h4>
				<v-radio-group class="mt-0" v-model="knowledgeMatavfallsMatsvinn" column>
					<v-radio label="Matavfall och matsvinn är samma sak" value="a"></v-radio>
					<v-radio label="Matavfall är mat som inte går att äta medan matsvinn är sådan mat som slängs men som egentligen skulle kunna äta" value="b"></v-radio>
					<v-radio label="Matavfall är allt som är animaliskt medans matsvinn är vegetariskt" value="c"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Vad får lämnas på återvinningsstationen (FTI)?</h4>
				<v-radio-group class="mt-0" v-model="knowledgeFti" column>
					<v-radio label="Endast förpackningar från hushållet" value="a"></v-radio>
					<v-radio label="Allt avfall från hushållet" value="b"></v-radio>
					<v-radio label="Möbler och grovsopor" value="c"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Vilken av följande räknas som en plastförpackning?</h4>
				<v-radio-group class="mt-0" v-model="knowledgePlastforpackning" column>
					<v-radio label="Tandborste" value="a"></v-radio>
					<v-radio label="Plastleksak" value="b"></v-radio>
					<v-radio label="Yoghurtburk" value="c"></v-radio>
				</v-radio-group>

				<h4 class="mb-3 mt-10">Som farligt avfall räknas sådant avfall som är giftigt/skadligt för människor och miljön. Vilket/vilka av följande är exempel på farligt avfall?</h4>
				<v-checkbox hide-details v-model="knowledgeWhatIsFarligtAvfall" value="a" label="Matolja"></v-checkbox>
				<v-checkbox	hide-details v-model="knowledgeWhatIsFarligtAvfall" value="b" label="Insektsspray"></v-checkbox>
				<v-checkbox	hide-details v-model="knowledgeWhatIsFarligtAvfall" value="c" label="Motorolja"></v-checkbox>
				<v-checkbox hide-details v-model="knowledgeWhatIsFarligtAvfall" value="d" label="Medel för fläckborttagning"></v-checkbox>
				<v-checkbox	hide-details v-model="knowledgeWhatIsFarligtAvfall" value="e" label="Konservburkar"></v-checkbox>
				<v-checkbox	hide-details v-model="knowledgeWhatIsFarligtAvfall" value="f" label="Nagellack"></v-checkbox>

				<div class="nudgd-btn inline survey-submit mt-10" @click="nextStep()">Gå vidare</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
				<div style="clear:both;"></div>
			</div>

			<div v-show="stepIndex === 3">
				<h3>Har du några förbättringsförslag?</h3>

				<h4 class="mb-3 mt-10">Hur tycker du att avfallshanteringen skulle kunna förbättras där du bor, t ex gällande rutiner, infrastruktur eller någon specifik typ av material?</h4>
	  			<v-textarea rows="4" hide-details solo v-model="doOthersRecycleCommentary2"></v-textarea>
				<div class="survey-help mt-2 mb-10">(Vänligen lämna inga personuppgifter i detta fält)</div>

		 		<p>Stort tack för att du ville hjälpa oss och svara på frågorna i enkäten!</p>
		 		<p>Om du har frågor angående enkäten eller avfallshanteringen i ditt hus går det bra att kontakta Maria Löfholm på Svenska Bostäder på <a href="mailto:maria.lofholm@svenskabostader.se">maria.lofholm@svenskabostader.se</a></p>

				<div class="nudgd-btn inline survey-submit mt-10" @click="submitResponse()">
					Skicka svar
				</div>
				<div class="nudgd-btn small survey-submit mt-10" @click="prevStep()">Tillbaka</div>
			</div>

		<v-progress-linear color="#00A19A" height="10" rounded class="mt-8" :value="(stepIndex + 1) / steps.length * 100"></v-progress-linear>
	</div>
</div>
</template>

<script>
	import axios from 'axios'
	import VueSlider from 'vue-slider-component'
	import 'vue-slider-component/theme/default.css'


  export default {
  	name: 'Vue',
  	components: {VueSlider},

  	mounted() {
  		this.uuid = Math.random().toString(36).substr(2, 5)
  		this.$store.state.surveyId = 6
  	},

  	data() {
  		return {
  			steps: [0, 1, 2, 3],
  			stepIndex: 0,
  			uuid: null,

  			personsInHoushold: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
  			personsInHousholdValue: null,
  			yearsInHoushold: ['1-2', '3-5', '6-10', '10+'],
  			yearsInHousholdValue: null,
  			address: null,
  			yearOfBirth: null,
  			gender: null,
  			childrenInHousehold: null,
  			sortFrequency: null,
  			assessedKnowledge: null,
  			assessedKnowledgeCommentary: null,
  			feelingWhenRecycling: null,
  			feelingWhenRecyclingCommentary: null,
  			importanceOfRecycling: null,
  			importanceOfRecyclingCommentary: null,
  			understandingOfRecycling: null,
  			understandingOfRecyclingCommentary: null,
  			informedAboutRecycling: null,
  			informedAboutRecyclingCommentary: null,
  			understandingOfWhatHappendsAfterRecycling: null,
  			understandingOfWhatHappendsAfterRecyclingCommentary: null,
  			easeOfRecycling: null,
  			easeOfRecyclingCommentary: null,
  			timeToRecycle: null,
  			timeToRecycleCommentary: null,
  			easeOfWaste: null,
  			easeOfWasteCommentary: null,
  			physicalEaseOfRecycling: null,
  			physicalEaseOfRecyclingCommentary: null,
  			spaceToRecycle: null,
  			spaceToRecycleCommentary: null,
  			doOthersRecycle: null,
  			doOthersRecycleCommentary: null,
  			doOthersRecycleCommentary2: null,
  			knowledgeAvfallstrappan: null,
  			knowledgeFarligtAvfall: null,
  			knowledgeMatavfallsMatsvinn: null,
  			knowledgeFti: null,
  			knowledgePlastforpackning: null,
  			knowledgeWhatIsFarligtAvfall: null,
  		}
  	},

  		methods: {
  			nextStep() {
  				window.scrollTo(0, 0)
  				this.stepIndex++
  			},

  			prevStep() {
  				window.scrollTo(0, 0)
  				this.stepIndex--
  			},

  			saveState() {
  				let {steps, personsInHoushold, yearsInHoushold, ...data} = this.$data

  				axios.post(this.$apiUrl + '/api/survey/6', {
  					...data,
  					seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
  					completed_pages: this.stepIndex,
  					slug: this.$store.state.endUser?.slug
  				})
  			},

  			submitResponse() {
  				let {steps, personsInHoushold, yearsInHoushold, ...data} = this.$data

  				axios.post(this.$apiUrl + '/api/survey/6', {
  					...data,
  					seconds_passed: performance ? parseInt(performance.now() / 1000) : null,
  					completed_pages: 4,
  					complete: true,
  					slug: this.$store.state.endUser?.slug
  				}).then(res => {
  					this.$router.push({name: 'SurveyThanks', params: {slug: this.$store.state.endUser?.slug}})
  	            })
  			}
  		},
  }
</script>
